import { Categoria } from './categoria';

export class Respuesta {
  respuesta: string;
  esCorrecta: boolean;
}

export class Pregunta {
  _id: string;
  pregunta: string;
  requiereImagen: boolean;
  imagen: string;
  feedbackCorrecto: string;
  feedbackIncorrecto: string;
  opcion1: Respuesta;
  opcion2: Respuesta;
  opcion3: Respuesta;
  opcion4: Respuesta;
  categoria: Categoria;
  opciones: Array<any>;
  nombreImagen?: any;

  constructor() {
    this.opcion1 = new Respuesta;
    this.opcion2 = new Respuesta;
    this.opcion3 = new Respuesta;
    this.opcion4 = new Respuesta;
    this.categoria = new Categoria;
    this.opciones = [];
  }
}



// WEBPACK FOOTER //
// ./src/dominio/pregunta.ts